"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFeeItems = exports.defaultBlockCount = exports.speeds = void 0;
const errors_1 = require("@ledgerhq/errors");
const cache_1 = require("@ledgerhq/live-network/cache");
const network_1 = __importDefault(require("@ledgerhq/live-network/network"));
const bignumber_js_1 = require("bignumber.js");
const invariant_1 = __importDefault(require("invariant"));
const explorer_1 = require("../../../explorer");
const getEstimatedFees = (0, cache_1.makeLRUCache)((currency) => __awaiter(void 0, void 0, void 0, function* () {
    const baseURL = (0, explorer_1.blockchainBaseURL)(currency);
    (0, invariant_1.default)(baseURL, `Fees for ${currency.id} are not supported`);
    const { data, status } = yield (0, network_1.default)({
        method: "GET",
        url: `${baseURL}/fees`,
    });
    if (data) {
        return data;
    }
    throw new errors_1.FeeEstimationFailed(`FeeEstimationFailed ${status}`, {
        httpStatus: status,
    });
}), c => c.id);
exports.speeds = {
    "1": "fast",
    "3": "medium",
    "6": "slow",
};
exports.defaultBlockCount = 3;
const getFeeItems = (currency) => __awaiter(void 0, void 0, void 0, function* () {
    const all = [];
    const fees = yield getEstimatedFees(currency);
    let defaultFeePerByte = new bignumber_js_1.BigNumber(0);
    for (const key of Object.keys(fees)) {
        const feePerByte = new bignumber_js_1.BigNumber(Math.ceil(fees[key] / 1000));
        const blockCount = parseInt(key, 10);
        if (blockCount === exports.defaultBlockCount)
            defaultFeePerByte = feePerByte;
        if (!Number.isNaN(blockCount) && !feePerByte.isNaN() && blockCount in exports.speeds) {
            all.push({
                key,
                speed: exports.speeds[blockCount],
                blockCount,
                feePerByte,
            });
        }
    }
    const items = all
        .sort((a, b) => a.blockCount - b.blockCount)
        .map(({ key, speed, feePerByte }) => ({
        key,
        speed,
        feePerByte,
    }));
    return {
        items,
        defaultFeePerByte,
    };
});
exports.getFeeItems = getFeeItems;
//# sourceMappingURL=index.js.map